Controller.$inject = ['$element'];

function Controller($element) {
    const self = this;

    self.sortingType = 'asc';
    
    self.$postLink = function() {
        const parentTr = $element.closest('tr');
        if (parentTr.length) {
            self.rowCtrl = parentTr.controller('huiTr');
            self.rowGroupCtrl = parentTr.controller('huiTrGroup');
        }
    };

    self.sortTableColumn = (direction, $event) => {
        if ($event) {
            $event.stopPropagation();
        }
        
        if (self.sortingType === direction) {
            self.sortingType = direction === 'asc' ? 'desc' : 'asc';
        } else {
            self.sortingType = direction;
        }

        if (self.onSortChanged) {
            self.onSortChanged({ direction: self.sortingType });
        }
    };

    self.onExpandButtonClick = ($event) => {
        $event.stopPropagation();
        $event.preventDefault();
        
        const native = $element[0];
        const parentTr = native?.closest('tr');
        
        if (!parentTr) {
            return;
        }
        const expandEvent = new CustomEvent('cellExpandClick', {
            bubbles: false,
            cancelable: false
        });
        parentTr.dispatchEvent(expandEvent);
    };

    self.getIsFirstCell = () => {
        const native = $element[0];
        return typeof native?.cellIndex === 'number' && native.cellIndex === 0;
    };

    self.getRow = () => {
        if (self.rowCtrl) {
            return self.rowCtrl;
        }
        return self.getParentRowDataFromCSS('hui-tr', true);
    };

    self.getRowGroup = () => {
        if (self.rowGroupCtrl) {
            return self.rowGroupCtrl;
        }
        return self.getParentRowDataFromCSS('hui-tr-group', false);
    };

    self.getParentRowDataFromCSS = (attributeName, includeParentLevel) => {
        const native = $element[0];
        const parentTr = native?.closest('tr');
        if (!parentTr || !parentTr.hasAttribute(attributeName)) {
            return null;
        }

        const data = {
            hasExpanded: parentTr.classList.contains('has-expanded'),
            expanded: parentTr.classList.contains('row-expanded'),
            loading: parentTr.classList.contains('loading')
        };

        if (includeParentLevel) {
            const parentLevelStr = window.getComputedStyle(parentTr).getPropertyValue('--parent-level').trim();
            data.parentLevel = parentLevelStr ? parseInt(parentLevelStr, 10) : undefined;
        }

        return data;
    };

    self.showRowExpandIconLeft = () => {
        if (!self.getIsFirstCell()) {
            return false;
        }

        const row = self.getRow();
        const hasExpandableContent = row?.hasExpanded;
        const isLoading = row?.loading;
        
        return !!(hasExpandableContent) || !!isLoading;
    };

    self.showRowExpandIconRight = () => {
        if (!self.getIsFirstCell()) {
            return false;
        }

        const rowGroup = self.getRowGroup();
        const hasExpandableContent = rowGroup?.hasExpanded;
        const isLoading = rowGroup?.loading;
        
        return !!(hasExpandableContent) || !!isLoading;
    };

    self.isRowExpanded = () => {
        const row = self.getRow();
        const rowGroup = self.getRowGroup();
        return row?.expanded || rowGroup?.expanded || false;
    };

    self.isRowLoading = () => {
        const row = self.getRow();
        const rowGroup = self.getRowGroup();
        return row?.loading || rowGroup?.loading || false;
    };

    self.rowExpandIconClass = () => {
        const rowGroup = self.getRowGroup();
        
        if (self.isRowLoading()) {
            return 'fa-spinner fa-spin';
        }
        
        if (rowGroup?.hasExpanded) {
            return self.isRowExpanded() ? 'fa-chevron-up' : 'fa-chevron-down';
        }
        
        if (self.isRowExpanded()) {
            return 'fa-chevron-down';
        }
        return 'fa-chevron-right transform-direction';
    };

    self.expandButtonAriaLabel = () => {
        if (self.isRowLoading()) {
            return 'Loading row details';
        }
        
        return self.isRowExpanded() ? 'Collapse row' : 'Expand row';
    };
}

export function HuiCell() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            stickyTop: '@',
            stickyBottom: '@',
            stickyStart: '@',
            stickyEnd: '@',
            as: '@',
            isDisabled: '<',
            isSortable: '<',
            onSortChanged: '&'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {

            const tagName = $attrs.as || 'td';

            return `
                <${tagName} ng-class="{
                    'stuck': $huiCtrl.stickyTop || $huiCtrl.stickyBottom || $huiCtrl.stickyStart || $huiCtrl.stickyEnd,
                    'stuck-top': $huiCtrl.stickyTop,
                    'stuck-bottom': $huiCtrl.stickyBottom,
                    'stuck-start': $huiCtrl.stickyStart,
                    'stuck-end': $huiCtrl.stickyEnd,
                    'disabled': $huiCtrl.isDisabled
                }"
                 ng-style="{
                   top: $huiCtrl.stickyTop,
                   bottom: $huiCtrl.stickyBottom,
                   left: $huiCtrl.stickyStart,
                   right: $huiCtrl.stickyEnd
                 }">
                    <div ng-if="$huiCtrl.isSortable" class="d-flex gap-1">
                        <span ng-transclude></span>
                        <span class="hui-sort-icons justify-content-center">
                            <i class="fa-caret-up"
                               ng-class="{'fa-solid': $huiCtrl.sortingType === 'asc', 'fa-light': $huiCtrl.sortingType !== 'asc'}"
                               ng-click="$huiCtrl.sortTableColumn('asc', $event)">
                            </i>
                            <i class="fa-caret-down"
                               ng-class="{'fa-solid': $huiCtrl.sortingType === 'desc', 'fa-light': $huiCtrl.sortingType !== 'desc'}"
                               ng-click="$huiCtrl.sortTableColumn('desc', $event)">
                            </i>
                        </span>
                    </div>
                    
                    <div ng-if="$huiCtrl.showRowExpandIconLeft()" class="d-flex align-items-center gap-1">
                        <hui-button 
                                variant="ghost"
                                color="primary"
                                ng-attr-aria-label="{{$huiCtrl.expandButtonAriaLabel()}}"
                                ng-attr-aria-expanded="{{$huiCtrl.isRowExpanded()}}"
                                ng-disabled="$huiCtrl.isRowLoading()"
                                ng-click="$huiCtrl.onExpandButtonClick($event)">
                            <i class="fa" ng-class="$huiCtrl.rowExpandIconClass()"></i>
                        </hui-button >
                        <span ng-transclude></span>
                    </div>
                    
                    <div ng-if="$huiCtrl.showRowExpandIconRight()" class="d-flex justify-content-between align-items-center">
                        <span ng-transclude></span>
                        <hui-button
                                variant="ghost"
                                color="primary"
                                ng-attr-aria-label="{{$huiCtrl.expandButtonAriaLabel()}}"
                                ng-attr-aria-expanded="{{$huiCtrl.isRowExpanded()}}"
                                ng-disabled="$huiCtrl.isRowLoading()"
                                ng-click="$huiCtrl.onExpandButtonClick($event)">
                            <i class="fa" ng-class="$huiCtrl.rowExpandIconClass()"></i>
                        </hui-button>
                    </div>
                    
                    <span ng-if="!$huiCtrl.isSortable && !$huiCtrl.showRowExpandIconLeft() && !$huiCtrl.showRowExpandIconRight()">
                        <span ng-transclude></span>
                    </span>      
             </${tagName}>
            `;
        }
    }
}